<template>
  <div class="scroll-dashboard-div dashboard-container content-wrappper" v-on:scroll="deactivatePopover">
    <div class="row">
      <div class="row welcome-banner">
        <div class="col-xs-12 col-sm-12 col-md-12 pl-0 pr-0">
          <div class="welcome-header-wrapper">
            <div class="col-xs-12 pl-15 welcome-header pr-0">Conformity Declaration Management by UL Solutions<span class="reserved">&#174;</span></div>
          </div>
          <div class="col-xs-12 pl-15 welcome-description">{{ $t('dashboardDescriptionPart1') }}</div>
          <div class="col-xs-12 pl-0 ptb-10">
            <button type="button" class="btn contact_us_button" @click="goToSupport()">{{ $t('contactUs') }}</button>
          </div>
        </div>
      </div>
      <div class="mt--45 col-xs-12 pr-0" v-if="this.permissions.indexOf('REG_TRACKER_RECORDS') !== -1">
        <div class="cards">
          <summary-card class="widget1" :widgetTrackplusFlag="widgetTrackplusFlag"
            :registrationCount="registrationCount" :devicesCount="devicesCount"
            :countriesCount="countriesCount"></summary-card>
          <pending-card class="widget2" :widgetTrackplusFlag="widgetTrackplusFlag" :pending_summary="pending_summary"
            :pendingVisible="pendingVisible" :openPopover="openPopover" @viewRegistration="viewRegistration"
            :permissions="permissions" :roleId="roleId" :roleInfo="roleInfo"></pending-card>
          <expiration-card class="widget3" :widgetTrackplusFlag="widgetTrackplusFlag"
            :expiration_details="expiration_details" :expiryVisible="expiryVisible" :openPopover="openPopover"
            @viewRegistration="viewRegistration"></expiration-card>
        </div>
      </div>
    </div>
    <div class="market_news_main">
       <market-news :roleInfo="roleInfo"></market-news>
    </div>

    <div class="notification-main">
      <div class="notifications">
        <span class="notifications_header">{{ $t('notifications') }}</span>
      </div>
      <notification-reg-tracker v-if="notificationTabName == 'registration-tracker'" :startDate="startDate"
        :endDate="endDate" :notificationsStarMarkCount="notificationsStarMarkCount"
        :dashboard=true type="dashboard-notifications"></notification-reg-tracker>

    </div>
    <permission-access-modal></permission-access-modal>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import cloneDeep from 'clone-deep';
import $ from 'jquery';
import * as d3 from 'd3v4';
import registrationDetailsPopup from '../Registrations/RegistrationDetailsPopup.vue';
import vSelect from '../UIComponents/TrackPlusSelect.vue';
import Loader from '../UIComponents/Loader.vue';
import PermissionAccessModal from '../Common/PermissionAccessModal.vue';
import { getChartsDataOverView, getCharts } from '../../apis/reports';
import { getDashboardSummary } from '../../apis/dashboard';
import { getRegistrationDetailsById } from '../../apis/registrations';
import validateRegDetailsData from '../../utils/registrationDetails';
import permissionsList from '../UIComponents/mixins/rbacPermissionsMixin';
import SummaryCard from '../TrackPlusDashboard/SummaryCard.vue';
import ExpirationCard from '../TrackPlusDashboard/ExpirationCard.vue';
import PendingCard from '../TrackPlusDashboard/PendingCard.vue';
import NotificationRegTracker from '../Notification/NotificationRegTracker.vue';
import EventBus from '../../utils/event-bus';
import MarketNews from '../MarketNews/MarketNews.vue';

export default {
  mixins: [permissionsList],
  props: ['roleId', 'roleInfo'],
  data() {
    return {
      widgetTrackplusFlag: true,
      permissions: [],
      loaderStatus: false,
      registrationCount: 0,
      devicesCount: 0,
      countriesCount: 0,
      charts: [],
      errors: [],
      ViewCountryList: false,
      mode: 'reports',
      editFlag: '',
      activeRegistration: {},
      actualProductData: [],
      data: [],
      registrationdata: [],
      productList: [],
      dataProduct: [],
      dataMapProduct: [],
      mapProductList: [],
      registrationIdList: [],
      mapRegistrationIdList: [],
      productDropDownLabel: 'All',
      mapProductDropDownLabel: 'All',
      marginTitle: 0,
      expiration_details: {},
      pending_summary: {},
      expiryVisible: [false, false, false, false],
      pendingVisible: [false, false, false],
      openPopover: false,
      clickPopover: false,
      mapData: [],
      mapDataloaded: false,
      country: '',
      countryList: [],
      disabledClrBtn: true,
      listView: false,
      isIslands: false,
      isExport: false,
      isProductSelected: false,
      isCountrySelected: false,
      isCheckedCounter: 0,
      worldMapId: 'worldMap',
      tablelistChartId: 'tableListChart',
      documentId: '',
      notificationTabName: '',
      notificationsStarMarkCount: {},
    };
  },
  components: {
    PermissionAccessModal,
    Loader,
    registrationDetailsPopup,
    vSelect,
    SummaryCard,
    ExpirationCard,
    PendingCard,
    NotificationRegTracker,
    MarketNews,
  },
  computed: {
    selectedMapCount() {
      return this.dataMapProduct.filter((dataObj) => dataObj.selected);
    },
  },
  methods: {
    goToSupport() {
      this.$router.push('/layout/support');
    },
    goToHeadlines() {
      // this.$router.push('/layout/headlines');
      this.$router.push({
        name: 'Headlines',
        params: { type: 'Pending' },
      });
    },

    openTour() {
      // this.$emit('mobilesidebar');
      // $('#basePopup').modal({
      //   backdrop: 'static',
      //   keyboard: false,
      // });
      EventBus.$emit('displayTour');
    },
    defaultStartAndEndDates() {
      const todayDate = new Date();
      const oneMonthOldDate = new Date();
      oneMonthOldDate.setMonth(oneMonthOldDate.getMonth() - 1);
      this.startDate = oneMonthOldDate;
      this.endDate = todayDate;
    },
    resetExportPopup() {
      this.documentId = '';
      $('#exportPdfImg').modal('hide');
    },
    async countrySelected() {
      this.disabledClrBtn = false;
      this.mapData = this.DupMapData.filter((item) => item.countryName === this.country);
      const islands = ['Réunion', 'Seychelles'];
      this.isIslands = false;
      if (islands.indexOf(this.country) !== -1) {
        this.isIslands = true;
      }
      this.isExport = false;
      this.isCountrySelected = true;
      // this.drawWorldMap(this.country);
    },
    clearEvent() {
      this.mapData = this.DupMapData;
      this.country = '';
      for (let i = 0; i < this.dataMapProduct.length; i += 1) {
        if (!this.dataMapProduct[i].selected) {
          this.dataMapProduct[i].selected = true;
        }
      }
      this.isExport = false;
      this.reRenderChart('map');
      this.disabledClrBtn = true;
      this.isProductSelected = false;
      this.isIslands = false;
    },
    countryLabel(country) {
      let countryName = country;
      if (window.innerWidth < 768 && country.length > 40) {
        const i = country.indexOf(' ', 30);
        countryName = `${country.substring(0, i)}<br>${country.substring(i + 1)}`;
      }
      return countryName;
    },
    async validateFeatures() {
      this.permissions = [];
      const servicesList = ['REG_TRACKER'];
      const modulesList = ['REG_TRACKER_RECORDS', 'REG_TRACKER_REPORTS'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
    },
    async viewRegistration(registrationId, type, index) {
      if (this.permissions.indexOf('REG_TRACKER_RECORDS') === -1) {
        $('#permissionAccessModal').modal({
          backdrop: 'static',
          keyboard: false,
        });
      } else {
        if (this.userRoleId === 4) {
          return;
        }
        this.loaderStatus = true;
        if (type) {
          if (type === 'expiry') {
            this.expiryVisible[index] = false;
          } else {
            this.pendingVisible[index] = false;
          }
          const all = document.getElementsByClassName('popper-custom-class');
          for (let i = 0; i < all.length; i += 1) {
            all[i].style.display = 'none';
          }
        }
        const selectedRegistration = await getRegistrationDetailsById(
          registrationId,
        );
        this.loaderStatus = false;
        if (selectedRegistration && selectedRegistration.error) {
          this.$notify({
            clear: true,
            group: 'custom-notification',
          });
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: 'Registration is not found!',
            group: 'custom-notification',
          });
        } else if (selectedRegistration) {
          this.activeRegistration = validateRegDetailsData(selectedRegistration);
          $('#registrationDetail').modal();
        }
      }
    },
    async getDashboardSummary() {
      this.loaderStatus = true;
      const {
        expiration_details: expirationDetails,
        pending_summary: pendingSummary,
      } = await getDashboardSummary();
      this.pending_summary = pendingSummary;
      this.expiration_details = expirationDetails;
      this.loaderStatus = false;
    },
    async getChartsDataOverView() {
      const data = await getChartsDataOverView();
      this.registrationCount = data.noOfRegistrations;
      this.devicesCount = data.noOfDevices;
      this.countriesCount = data.noOfCountries;
    },
    toggleSummary() {
      this.isIslands = false;
      this.mapData = this.DupMapData;
      this.country = '';
      this.disabledClrBtn = true;
      if (!this.listView) {
        // this.drawWorldMap();
      }
      this.listView = !this.listView;
      if (this.ViewCountryList) {
        this.country = '';
      }
      if (this.isProductSelected) {
        this.disabledClrBtn = false;
      }
      this.ViewCountryList = !this.ViewCountryList;
    },
    async loadVerticalStackedBarChart() {
      this.loaderStatus = true;
      this.data = [];
      this.registrationdata = [];
      this.productList = [
        { productName: 'All', registrationId: '-1', selected: true },
      ];
      this.dataProduct = [
        { productName: 'All', registrationId: '-1', selected: true },
      ];
      this.dataMapProduct = [
        { productName: 'All', registrationId: '-1', selected: true },
      ];
      this.registrationdata = await getCharts();
      let countryPresent = false;
      let newCountryObj = {};
      let statusListParam = '';
      const statusList = ['Active', 'Pending', 'Expiring soon', 'Expired'];

      this.registrationdata.forEach((curRegistrationData) => {
        if (!curRegistrationData.country_code) {
          return;
        }
        countryPresent = false;
        for (let i = 0; i < this.data.length; i += 1) {
          if (curRegistrationData.country_code === this.data[i].country) {
            for (let j = 0; j < statusList.length; j += 1) {
              if (
                curRegistrationData.status.toLowerCase()
                === statusList[j].toLowerCase()
              ) {
                this.data[i][statusList[j]] += 1;
                statusListParam = `${statusList[j]
                  .split(' ')[0]
                  .toLowerCase()}_list`;
                this.data[i][statusListParam].push({
                  id: curRegistrationData.registration_id,
                  name: curRegistrationData.product_name,
                });
                break;
              }
            }
            this.data[i].totalRegistration += 1;
            countryPresent = true;
            break;
          }
        }
        if (countryPresent === false) {
          newCountryObj = {};
          newCountryObj.country = curRegistrationData.country_code;
          newCountryObj.countryName = curRegistrationData.country_name;
          statusList.forEach((status) => {
            newCountryObj[status] = 0;
            statusListParam = `${status.split(' ')[0].toLowerCase()}_list`;
            newCountryObj[statusListParam] = [];
            if (
              curRegistrationData.status.toLowerCase() === status.toLowerCase()
            ) {
              newCountryObj[status] += 1;
              newCountryObj[statusListParam].push({
                id: curRegistrationData.registration_id,
                name: curRegistrationData.product_name,
              });
            }
          });
          newCountryObj.totalRegistration = 1;
          this.data.push(newCountryObj);
        }
        this.prepareProductList(curRegistrationData);
      });
      this.mapDataloaded = true;
      this.mapData = cloneDeep(this.data);
      this.DupMapData = cloneDeep(this.data);
      this.mapProductList = cloneDeep(this.productList);
      this.countryList = [];
      for (let i = 0; i < this.DupMapData.length; i += 1) {
        this.countryList.push(this.DupMapData[i].countryName);
      }
      this.drawVerticalStackedBarChart();
      // this.drawWorldMap();
    },

    prepareProductList(curRegistrationData) {
      let productPresent = false;
      for (let i = 0; i < this.productList.length; i += 1) {
        if (
          curRegistrationData.registration_id
          === this.productList[i].registrationId
        ) {
          productPresent = true;
          break;
        }
      }
      if (productPresent === false) {
        this.productList.push({
          productName: curRegistrationData.product_name,
          registrationId: curRegistrationData.registration_id,
          selected: true,
        });
        this.registrationIdList.push(curRegistrationData.registration_id);
        if (
          this.actualProductData.indexOf(curRegistrationData.product_name)
          === -1
        ) {
          this.actualProductData.push(curRegistrationData.product_name);
          this.dataProduct.push({
            productName: curRegistrationData.product_name,
            registrationId: curRegistrationData.registration_id,
            selected: true,
          });
          this.dataMapProduct.push({
            productName: curRegistrationData.product_name,
            registrationId: curRegistrationData.registration_id,
            selected: true,
          });
        }
      }
    },

    filterCountryChartData(chartType) {
      let countryPresent = false;
      let newCountryObj = {};
      let statusListParam = '';
      this.data = [];
      this.mapData = [];
      const statusList = ['Active', 'Pending', 'Expiring soon', 'Expired'];

      if (chartType === 'stack') {
        this.registrationdata.forEach((curRegistrationData) => {
          if (curRegistrationData.country_code === null) {
            return;
          }
          countryPresent = false;
          for (let i = 0; i < this.data.length; i += 1) {
            if (curRegistrationData.country_code === this.data[i].country) {
              for (let j = 0; j < statusList.length; j += 1) {
                if (
                  curRegistrationData.status.toLowerCase()
                  === statusList[j].toLowerCase()
                  && this.registrationIdList.indexOf(
                    curRegistrationData.registration_id,
                  ) > -1
                ) {
                  this.data[i][statusList[j]] += 1;
                  statusListParam = `${statusList[j]
                    .split(' ')[0]
                    .toLowerCase()}_list`;
                  this.data[i][statusListParam].push({
                    id: curRegistrationData.registration_id,
                    name: curRegistrationData.product_name,
                  });
                  break;
                }
              }
              this.data[i].totalRegistration += 1;
              countryPresent = true;
              break;
            }
          }
          if (
            countryPresent === false
            && this.registrationIdList.indexOf(
              curRegistrationData.registration_id,
            ) > -1
          ) {
            newCountryObj = {};
            newCountryObj.country = curRegistrationData.country_code;
            newCountryObj.countryName = curRegistrationData.country_name;
            for (let j = 0; j < statusList.length; j += 1) {
              newCountryObj[statusList[j]] = 0;
              statusListParam = `${statusList[j]
                .split(' ')[0]
                .toLowerCase()}_list`;
              newCountryObj[statusListParam] = [];
              if (
                curRegistrationData.status.toLowerCase()
                === statusList[j].toLowerCase()
              ) {
                newCountryObj[statusList[j]] += 1;
                newCountryObj[statusListParam].push({
                  id: curRegistrationData.registration_id,
                  name: curRegistrationData.product_name,
                });
              }
            }
            newCountryObj.totalRegistration = 1;
            this.data.push(newCountryObj);
          }
        });
        this.drawVerticalStackedBarChart();
      } else if (chartType === 'map') {
        this.registrationdata.forEach((curRegistrationData) => {
          if (curRegistrationData.country_code === null) {
            return;
          }
          countryPresent = false;
          for (let i = 0; i < this.mapData.length; i += 1) {
            if (curRegistrationData.country_code === this.mapData[i].country) {
              for (let j = 0; j < statusList.length; j += 1) {
                if (
                  curRegistrationData.status.toLowerCase()
                  === statusList[j].toLowerCase()
                  && this.mapRegistrationIdList.indexOf(
                    curRegistrationData.registration_id,
                  ) > -1
                ) {
                  this.mapData[i][statusList[j]] += 1;
                  statusListParam = `${statusList[j]
                    .split(' ')[0]
                    .toLowerCase()}_list`;
                  this.mapData[i][statusListParam].push({
                    id: curRegistrationData.registration_id,
                    name: curRegistrationData.product_name,
                  });
                  break;
                }
              }
              this.mapData[i].totalRegistration += 1;
              countryPresent = true;
              break;
            }
          }
          if (
            countryPresent === false
            && this.mapRegistrationIdList.indexOf(
              curRegistrationData.registration_id,
            ) > -1
          ) {
            newCountryObj = {};
            newCountryObj.country = curRegistrationData.country_code;
            newCountryObj.countryName = curRegistrationData.country_name;
            statusList.forEach((status) => {
              newCountryObj[status] = 0;
              statusListParam = `${status.split(' ')[0].toLowerCase()}_list`;
              newCountryObj[statusListParam] = [];
              if (
                curRegistrationData.status.toLowerCase()
                === status.toLowerCase()
              ) {
                newCountryObj[status] += 1;
                newCountryObj[statusListParam].push({
                  id: curRegistrationData.registration_id,
                  name: curRegistrationData.product_name,
                });
              }
            });
            newCountryObj.totalRegistration = 1;
            this.mapData.push(newCountryObj);
          }
        });
        this.DupMapData = this.mapData;
        // this.drawWorldMap();
      }
    },

    drawVerticalStackedBarChart() {
      const parentWidth = this.$el.clientWidth;
      const margin = {
        top: 20,
        right: 40,
        bottom: 50,
        left: 40,
      };
      const width = parentWidth / 1.5;
      const height = 300;

      this.marginTitle = (parentWidth - (width + margin.left + margin.right)) / 2;

      const legendWidth = 100;
      const legendRectSize = 9;
      const legendSpacing = 3;
      const statusList = ['Expired', 'Expiring soon', 'Pending', 'Active'];
      const statusColor = ['#ff0606', '#ffaa49', '#4f90c3', '#013a68'];

      d3.select('#stackedBarChartDiv svg').remove();

      const svg = d3
        .select('#stackedBarChartDiv')
        .append('svg')
        .attr('id', 'stackedBarChart')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom);

      // const isTooltipHovered = false;

      d3.select('.country-tooltip').html('');
      const divTooltip = d3.select('.country-tooltip');

      divTooltip.append('div').attr('class', 'header');
      divTooltip.append('div').attr('class', 'body');

      let statusId = '';
      statusList.forEach((status) => {
        statusId = status.split(' ')[0].toLowerCase();
        divTooltip
          .select('.body')
          .append('div')
          .attr('class', 'panel list-group')
          .attr('id', `${statusId}-panel`);
      });

      const g = svg
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`);

      const x = d3
        .scaleBand()
        .rangeRound([0, width - legendWidth])
        .padding(0.3)
        .align(0.3);

      const y = d3.scaleLinear().rangeRound([height, 0]);

      const z = d3
        .scaleOrdinal()
        .range(['#013a68', '#4f90c3', '#ffaa49', '#ff0606']);

      const keys = ['Active', 'Pending', 'Expiring soon', 'Expired'];

      this.data.sort((a, b) => b.totalRegistration - a.totalRegistration);
      x.domain(this.data.map((d) => d.country));
      const yTop = d3.max(this.data, (d) => d.totalRegistration);
      const yMax = yTop <= 5 ? 5 : yTop;
      y.domain([0, yMax]).nice();
      // y.domain([0, d3.max(this.data, function(d) { return d.totalRegistration; })]).nice();
      z.domain(keys);

      // add the Y gridlines
      g.append('g')
        .attr('class', 'grid')
        .call(
          d3
            .axisLeft(y)
            .ticks(5, 's')
            .tickSize(-width + legendWidth)
            .tickFormat(''),
        );

      g.selectAll('.grid line, .grid path')
        .attr('stroke', 'lightgrey')
        .attr('stroke-opacity', 0.7);

      const stack = d3
        .stack()
        .keys(keys.reverse())
        .order(d3.stackOrderNone)
        .offset(d3.stackOffsetNone);

      const series = stack(this.data);

      g.append('g')
        .selectAll('g')
        .data(series)
        .enter()
        .append('g')
        .attr('fill', (d) => z(d.key))
        .selectAll('rect')
        .data((d) => d)
        .enter()
        .append('rect')
        .attr('class', 'bar')
        .attr('x', (d) => x(d.data.country))
        .attr('y', (d) => y(d[1]))
        .attr('height', (d) => y(d[0]) - y(d[1]))
        .attr('width', x.bandwidth());

      g.selectAll('.bar')
        .on('mousemove', (d) => {
          const barLeft = parseFloat(d3.select(this).attr('x'))
            + parseFloat(svg.node().getBoundingClientRect().left)
            + parseFloat(d3.select(this).attr('width'))
            + 50;
          divTooltip
            .style('left', `${barLeft}px`)
            .style('top', `${d3.event.pageY - 40}px`);

          d3.select('.tracker-map-tooltip .header').html(
            `<span class="flag-icon flag-icon-squared flag-icon-${d.data.country.toLowerCase()}"></span>${d.data.countryName
            }`,
          );

          let statusLC = '';
          let linkStr = '';

          statusList.forEach((status, index) => {
            statusLC = status.split(' ')[0].toLowerCase();
            if (d.data[`${statusLC}_list`].length > 0) {
              d3.select(`#${statusLC}-panel`).html(
                `<a id="${statusLC}-group" class="list-group-item parent collapsed" data-toggle="collapse" data-target="#${statusLC}"></a><div id="${statusLC}" class="sublinks collapse"></div>`,
              );
              d3.select(`#${statusLC}-group`).html(
                `${d.data[`${statusLC}_list`].length
                } ${status.toLowerCase()} registrations:`,
              );
              d3.select(`#${statusLC}-group`).style(
                'color',
                statusColor[index],
              );
              linkStr = '';
              d.data[`${statusLC}_list`].forEach((product) => {
                linkStr += `<a class="list-group-item small" slot="${product.id}">${product.name}</a>`;
              });
              d3.select(`.tracker-map-tooltip .list-group #${statusLC}`).html(
                linkStr,
              );
            } else {
              d3.select(`#${statusLC}-panel`).html('');
              d3.select(`#${statusLC}-group`).html('');
              d3.select(`.tracker-map-tooltip .list-group #${statusLC}`).html(
                '',
              );
            }
          });

          d3.select('.tracker-map-tooltip').style('display', 'block');
        })
        .on('mouseout', () => {
          setTimeout(() => {
            d3.select('.tracker-map-tooltip').style('display', 'none');
          }, 700);
        });

      const xAxis = d3.axisBottom(x).tickSize(0);

      g.append('g')
        .attr('class', 'axis')
        .attr('transform', `translate(0,${height})`)
        .call(xAxis);

      g.selectAll('.tick text')
        .style('font-family', 'Open Sans')
        .style('font-size', '13px')
        .style('font-weight', '500')
        .style('fill', '#2185D0')
        .attr('y', '30');

      g.append('g')
        .attr('transform', 'translate(0, 0)')
        .attr('class', 'axis')
        .call(
          d3
            .axisLeft(y)
            .ticks(5, 's')
            .tickFormat(d3.format('d')),
        )
        .append('text')
        .attr('x', 2)
        .attr('y', y(y.ticks().pop()) + 0.5)
        .attr('dy', '0.32em')
        .attr('fill', '#2185D0')
        .attr('font-weight', 'bold')
        .attr('text-anchor', 'start');

      g.selectAll('.tick text')
        .style('font-family', 'Open Sans')
        .style('font-size', '13px')
        .style('font-weight', '500')
        .style('fill', '#2185D0');

      g.selectAll('.axis path, .tick line')
        .attr('stroke', 'lightgrey')
        .attr('stroke-opacity', 0.7);

      const legend = svg
        .append('g')
        .attr('font-size', 10)
        .attr('text-anchor', 'start')
        .attr(
          'transform',
          `translate(${width - legendWidth + margin.left + 10},${margin.top})`,
        )
        .selectAll('g')
        .data(keys.reverse())
        .enter()
        .append('g')
        .attr('transform', (d, i) => `translate(0,${i * 20})`);

      legend
        .append('rect')
        .attr('width', legendRectSize)
        .attr('height', legendRectSize)
        .attr('fill', z);

      legend
        .append('text')
        .style('font-size', '14px')
        .style('font-weight', '500')
        .attr('fill', '#2185D0')
        .attr('x', legendRectSize + legendSpacing + 4)
        .attr('y', legendRectSize - legendSpacing + 4)
        .text((d) => d);

      // Prep the tooltip bits, initial display is hidden
      const tooltip = g
        .append('g')
        .attr('class', 'toolTip')
        .style('display', 'none');

      tooltip
        .append('rect')
        .attr('width', 30)
        .attr('height', 20)
        .attr('fill', 'white');

      tooltip
        .append('text')
        .attr('x', 15)
        .attr('dy', '1.2em')
        .style('text-anchor', 'middle')
        .attr('font-size', '12px')
        .attr('font-weight', 'bold');

      this.loaderStatus = false;
    },

    drawWorldMap(countryName = false) {
      if (this.isExport) {
        return;
      }
      d3.format(',');
      const parentWidth = this.$el.clientWidth;
      const clientHeight = window.innerHeight;
      const margin = {
        top: 50,
        right: 40,
        bottom: 0,
        left: 40,
      };
      const width = parentWidth - 50;
      const height = 500 - margin.top - margin.bottom;
      const nonZoomCoutries = ['European Union', 'United States of America', 'Russia'];
      let keys = ['Active', 'Pending', 'Expiring soon', 'Expired'];
      const color = d3
        .scaleOrdinal()
        .range(['#013a68', '#4f90c3', '#ffaa49', '#ff0606']);
      color.domain(keys);
      keys = keys.reverse();

      const statusList = ['Expired', 'Expiring soon', 'Pending', 'Active'];
      const statusColor = ['#ff0606', '#ffaa49', '#4f90c3', '#013a68'];
      const statusImg = [
        '/static/images/icons/alert_triangle.svg',
        '/static/images/icons/expiring_soon.svg',
        '/static/images/icons/pending_icon.svg',
        '/static/images/icons/active_icon.svg',
      ];

      d3.select('#worldMapDiv svg').remove();

      const svg = d3
        .select('#worldMapDiv')
        .append('svg')
        .attr('id', 'worldMap')
        .attr('width', width)
        .attr('height', height);

      // const center = [width / 2, height / 2];

      const g = svg.append('g').attr('class', 'map');
      d3.select('.tracker-map-tooltip').html('');
      d3.select('.tracker-map-tooltip').attr('class', 'tracker-map-tooltip remove_after');
      const tooltip = d3.select('.tracker-map-tooltip');
      tooltip.append('div').attr('class', 'header');
      tooltip
        .append('div')
        .attr('class', 'body')
        .attr('id', 'accordian');

      let statusId = '';
      statusList.forEach((status) => {
        statusId = status.split(' ')[0].toLowerCase();
        tooltip
          .select('.body')
          .append('div')
          .attr('class', 'panel list-group')
          .attr('id', `${statusId}-panel`);
      });
      const projection = d3.geoMercator()
        .scale(120)
        .translate([width / 2, height / 1.5]);
      const that = this;
      this.loaderStatus = true;
      d3.json('/static/json/resources-world-map.json', (error, world) => {
        const countryList = world.features;
        let europeanUnionFound = false;
        const europeanUnionObj = {};
        const totalRegistrationData = {};
        if (!this.isCountrySelected) {
          this.countryList = [];
        }
        this.mapData.forEach((registrationData) => {
          let countryFound = false;
          if (!this.isCountrySelected) {
            this.countryList.push(registrationData.countryName);
          }
          this.countryList = [...new Set(this.countryList)];
          const heighestRecord = keys.reduce((a, b) => {
            if (registrationData[a] > registrationData[b]) {
              return a;
            } if (registrationData[a] === registrationData[b]) {
              return a;
            }
            return b;
          });
          for (let i = 0; i < countryList.length; i += 1) {
            if (
              countryList[i].properties.iso_a2.toLowerCase()
              === registrationData.country.toLowerCase()
            ) {
              countryFound = true;
              keys.forEach((status) => {
                const statusListParam = `${status
                  .split(' ')[0]
                  .toLowerCase()}_list`;
                countryList[i][statusListParam] = registrationData[statusListParam];
              });
              if (registrationData[heighestRecord] > 0) {
                countryList[i].color = color(heighestRecord);
                let customCount = 0;
                let statusLC = '';
                statusList.forEach((status) => {
                  statusLC = status.split(' ')[0].toLowerCase();
                  customCount += registrationData[`${statusLC}_list`].length;
                });
                countryList[i].count = customCount;
                countryList[i].countryName = registrationData.countryName;
                totalRegistrationData.key = registrationData.country;
                totalRegistrationData[registrationData.country] = customCount;
              }
              break;
            }
          }
          if (!countryFound) {
            if (registrationData.country.toLowerCase() === 'eu') {
              europeanUnionFound = true;
              keys.forEach((status) => {
                const statusListParam = `${status
                  .split(' ')[0]
                  .toLowerCase()}_list`;
                europeanUnionObj[statusListParam] = registrationData[statusListParam];
              });
              if (registrationData[heighestRecord] > 0) {
                europeanUnionObj.color = color(heighestRecord);
                europeanUnionObj.count = registrationData.totalRegistration;
              }
              europeanUnionObj.countryName = registrationData.countryName;
            }
          }
        });
        const countriesPath = g
          .selectAll('.country')
          .data(countryList)
          .enter();
        const zoom = d3
          .zoom()
          .scaleExtent([1, 2000])
          .on('zoom', () => {
            g.attr('transform', d3.event.transform);
          });
        const path = d3.geoPath().projection(projection);
        svg.call(zoom);
        function zoonOnCountrySelected(d) {
          const bounds = path.bounds(d);
          const dx = bounds[1][0] - bounds[0][0];
          const dy = bounds[1][1] - bounds[0][1];
          const x = (bounds[0][0] + bounds[1][0]) / 2;
          const y = (bounds[0][1] + bounds[1][1]) / 2;
          const scale = Math.max(1, Math.min(100, 0.9 / Math.max(dx / width, dy / height)));
          const translate = [width / 2 - scale * x, height / 2 - scale * y];
          if (nonZoomCoutries.indexOf(that.country) === -1) {
            svg.transition()
              .duration(100)
              .call(zoom.transform, d3.zoomIdentity.translate(translate[0], translate[1]).scale(scale));
          }
        }
        let targetScale = d3.zoomTransform(svg).k;
        countriesPath
          .append('path')
          .attr('fill', (d) => {
            let customColor = '#e6e6e6';
            if (countryName && d.properties.admin === countryName) {
              customColor = d.color;
            }
            return customColor;
          })
          .attr('stroke', (d) => {
            let customColor = '#fff';
            if (countryName && d.properties.admin === countryName) {
              customColor = d.color;
            }
            return customColor;
          })
          .attr('stroke-width', (d) => {
            let value = 0.1;
            if (d.properties.admin === 'United States Minor Outlying Islands' || d.properties.admin === 'Kiribati') {
              value = 2;
            }
            return value;
          })
          .attr('d', path)
          .style('fill', (d) => {
            if (countryName && (d.properties.admin === countryName)) {
              zoonOnCountrySelected(d);
            }
            return d.color;
          })
          .on('click', zoonOnCountrySelected)
          .on('mousemove', (d) => {
            if (!d.count) {
              return;
            }

            const toolTipSelector = $('.tracker-map-tooltip');
            const tooltipY = (d3.event.pageY + toolTipSelector.outerHeight(true)) > clientHeight ? d3.event.pageY - toolTipSelector.outerHeight(true) : d3.event.pageY;
            tooltip
              .style('left', `${d3.event.pageX}px`)
              .style('top', `${tooltipY}px`);

            d3.select('.tracker-map-tooltip .header').html(
              `<span class="flag-icon flag-icon-squared flag-icon-${d.properties.iso_a2.toLowerCase()} country_flag"></span>`
              + `<span class="countryCustomCss-tooltip">${d.countryName}</span>`
              + `</span><span class="total_count">${totalRegistrationData[d.properties.iso_a2]
              }</span>`,
            );

            let statusLC = '';
            let linkStr = '';
            let statusImage = '';
            statusList.forEach((status) => {
              statusLC = status.split(' ')[0].toLowerCase();
              if (d[`${statusLC}_list`] && d[`${statusLC}_list`].length > 0) {
                if (status === 'Expired') {
                  [statusImage] = statusImg;
                } else if (status === 'Expiring soon') {
                  [, statusImage] = statusImg;
                } else if (status === 'Pending') {
                  [, , statusImage] = statusImg;
                } else if (status === 'Active') {
                  [, , , statusImage] = statusImg;
                }
                d3.select(`#${statusLC}-panel`).html(
                  `<img class="img_status" src ="${statusImage}"><a id="${statusLC}-group" class="list-group-item parent collapsed" data-toggle="collapse" data-parent="#accordian" data-target="#${statusLC}"></a><div id="${statusLC}" class="sublinks collapse"></div>`,
                );
                d3.select(`#${statusLC}-group`).html(
                  `${status}<span class="individual_count">${d[`${statusLC}_list`].length
                  }</span>`,
                );
                // d3.select('#' + statusLC +'-group').style('color', statusColor[index]);
                linkStr = '';
                d[`${statusLC}_list`].forEach((product) => {
                  linkStr += `<a class="list-group-item small" slot="${product.id}">${product.name}</a>`;
                });
                d3.select(`.tracker-map-tooltip .list-group #${statusLC}`).html(
                  linkStr,
                );
              } else {
                d3.select(`#${statusLC}-panel`).html('');
                d3.select(`#${statusLC}-group`).html('');
                d3.select(`.tracker-map-tooltip .list-group #${statusLC}`).html(
                  '',
                );
              }
            });

            d3.select('.tracker-map-tooltip .sublinks').style('overflow-y', 'auto');
            d3.select('.tracker-map-tooltip').style('display', 'block');
          })
          .on('mouseout', () => {
            setTimeout(() => {
              d3.select('.tracker-map-tooltip').style('display', 'none');
            }, 1000);
          });
        let europeanCentroid = [];
        if (europeanUnionFound) {
          countriesPath
            .selectAll('path')
            .filter((d) => {
              if (d.properties.iso_a2.toLowerCase() === 'dk') {
                europeanCentroid = path.centroid(d);
              }
              return (
                d.properties.region_un.toLowerCase() === 'european union'
                && !d.color
              );
            })
            .style('fill', () => europeanUnionObj.color)
            .on('mousemove', (d) => {
              if (!europeanUnionObj.count) {
                return;
              }
              const toolTipSelector = $('.tracker-map-tooltip');
              const tooltipY = (d3.event.pageY + toolTipSelector.outerHeight(true)) > clientHeight ? d3.event.pageY - toolTipSelector.outerHeight(true) : d3.event.pageY;
              tooltip
                .style('left', `${d3.event.pageX}px`)
                .style('top', `${tooltipY}px`);

              d3.select('.tracker-map-tooltip .header').html(
                `<span class="flag-icon flag-icon-squared flag-icon-eu"></span>${d.properties.region_un}`,
              );

              let statusLC = '';
              let linkStr = '';
              let statusImage = '';
              statusList.forEach((status, index) => {
                statusLC = status.split(' ')[0].toLowerCase();
                if (
                  europeanUnionObj[`${statusLC}_list`]
                  && europeanUnionObj[`${statusLC}_list`].length > 0
                ) {
                  if (status === 'Expired') {
                    [statusImage] = statusImg;
                  } else if (status === 'Expiring soon') {
                    [, statusImage] = statusImg;
                  } else if (status === 'Pending') {
                    [, , statusImage] = statusImg;
                  } else if (status === 'Active') {
                    [, , , statusImage] = statusImg;
                  }
                  d3.select(`#${statusLC}-panel`).html(
                    `<img class="img_status" src ="${statusImage}"><a id="${statusLC}-group" class="list-group-item parent collapsed" data-toggle="collapse"  data-parent="#accordian" data-target="#${statusLC}" ></a><div id="${statusLC}" class="sublinks collapse"></div>`,
                  );
                  d3.select(`#${statusLC}-group`).html(
                    `${status}<span class="individual_count">${europeanUnionObj[`${statusLC}_list`].length
                    }</span>`,
                  );
                  d3.select(`#${statusLC}-group`).style(
                    'color',
                    statusColor[index],
                  );
                  linkStr = '';
                  europeanUnionObj[`${statusLC}_list`].forEach((product) => {
                    linkStr += `<a class="list-group-item small" slot="${product.id}">${product.name}</a>`;
                  });
                  d3.select(
                    `.tracker-map-tooltip .list-group #${statusLC}`,
                  ).html(linkStr);
                } else {
                  d3.select(`#${statusLC}-panel`).html('');
                  d3.select(`#${statusLC}-group`).html('');
                  d3.select(
                    `.tracker-map-tooltip .list-group #${statusLC}`,
                  ).html('');
                }
              });
              d3.select('.tracker-map-tooltip .sublinks').style('overflow-y', 'auto');
              d3.select('.tracker-map-tooltip').style('display', 'block');
            })
            .on('mouseout', () => {
              setTimeout(() => {
                d3.select('.tracker-map-tooltip').style('display', 'none');
              }, 1000);
            });
        }

        g
          .selectAll('.count-text')
          .data(countryList)
          .enter()
          .append('text')
          .attr('class', 'count-text')
          .attr('transform', (d) => `translate(${path.centroid(d)})`)
          .text((d) => d.count)
          .attr('dx', '-0.38em')
          .attr('dy', (d) => {
            if (d.properties.iso_a2 === 'CA' || d.properties.iso_a2 === 'US') {
              return '2.25em';
            }
            return '0.25em';
          })
          .attr('font-family', 'Open Sans')
          .attr('font-size', (d) => {
            if (countryName && (d.properties.admin === countryName)) {
              return '0px';
            }
            return '12px';
          })
          .attr('font-weight', '500')
          .attr('fill', () => '#000');

        g.append('text')
          .attr('class', 'count-text')
          .attr('transform', `translate(${europeanCentroid})`)
          .text(europeanUnionObj.count)
          .attr('dx', '1em')
          .attr('dy', '0.1em')
          .attr('font-family', 'Open Sans')
          .attr('font-size', '12px')
          .attr('font-weight', '500')
          .attr('fill', () => '#000')
          .on('mousemove', (d) => {
            if (!europeanUnionObj.count) {
              return;
            }
            const toolTipSelector = $('.tracker-map-tooltip');
            const tooltipY = (d3.event.pageY + toolTipSelector.outerHeight(true)) > clientHeight ? d3.event.pageY - toolTipSelector.outerHeight(true) : d3.event.pageY;
            tooltip
              .style('left', `${d3.event.pageX}px`)
              .style('top', `${tooltipY}px`);

            d3.select('.tracker-map-tooltip .header').html(
              `<span class="flag-icon flag-icon-squared flag-icon-eu"></span>${d.properties.region_un}`,
            );

            let statusLC = '';
            let linkStr = '';
            statusList.forEach((status, index) => {
              statusLC = status.split(' ')[0].toLowerCase();
              if (
                europeanUnionObj[`${statusLC}_list`]
                && europeanUnionObj[`${statusLC}_list`].length > 0
              ) {
                d3.select(`#${statusLC}-panel`).html(
                  `<a id="${statusLC}-group" class="list-group-item parent collapsed" data-toggle="collapse" data-target="#${statusLC}"></a><div id="${statusLC}" class="sublinks collapse"></div>`,
                );
                d3.select(`#${statusLC}-group`).html(
                  `${europeanUnionObj[`${statusLC}_list`].length
                  } ${status.toLowerCase()} registrations:`,
                );
                d3.select(`#${statusLC}-group`).style(
                  'color',
                  statusColor[index],
                );
                linkStr = '';
                europeanUnionObj[`${statusLC}_list`].forEach((product) => {
                  linkStr += `<a class="list-group-item small" slot="${product.id}">${product.name}</a>`;
                });
                d3.select(`.tracker-map-tooltip .list-group #${statusLC}`).html(
                  linkStr,
                );
              } else {
                d3.select(`#${statusLC}-panel`).html('');
                d3.select(`#${statusLC}-group`).html('');
                d3.select(`.tracker-map-tooltip .list-group #${statusLC}`).html(
                  '',
                );
              }
            });

            d3.select('.tracker-map-tooltip').style('display', 'block');
          })
          .on('mouseout', () => {
            setTimeout(() => {
              d3.select('.tracker-map-tooltip').style('display', 'none');
            }, 1000);
          });
        d3.select('#zoom-in').on('click', () => {
          const scale = targetScale;
          const extent = zoom.scaleExtent();
          const factor = 1.2;
          if (targetScale >= extent[1]) {
            return;
          }
          targetScale = scale * factor;
          svg
            .transition()
            .duration(500)
            .call(zoom.scaleBy, targetScale);
        });

        d3.select('#zoom-out').on('click', () => {
          const scale = targetScale;
          const extent = zoom.scaleExtent();
          const factor = 1 / 1.2;
          if (targetScale <= extent[0]) {
            return;
          }
          targetScale = scale * factor;
          svg
            .transition()
            .duration(500)
            .call(zoom.scaleTo, targetScale);
        });
        d3.select('#reset').on('click', () => {
          targetScale = 1;
          svg
            .transition()
            .duration(100)
            .call(zoom.transform, d3.zoomIdentity);
        });
        that.loaderStatus = false;
        svg.style('display', 'initial');
      });
    },
    toggleCBValue(chartType, option) {
      if (chartType === 'stack') {
        let allSelected = true;
        for (let i = 0; i < this.dataProduct.length; i += 1) {
          if (this.dataProduct[i].registrationId === option.registrationId) {
            this.dataProduct[i].selected = !this.dataProduct[i].selected;
            break;
          }
        }
        for (let i = 0; i < this.dataProduct.length; i += 1) {
          if (
            this.dataProduct[i].productName !== 'All'
            && !this.dataProduct[i].selected
          ) {
            allSelected = false;
            break;
          }
        }
        if (option.productName === 'All') {
          for (let i = 0; i < this.dataProduct.length; i += 1) {
            this.dataProduct[i].selected = this.dataProduct[0].selected;
          }
        } else this.dataProduct[0].selected = allSelected;
      } else if (chartType === 'map') {
        let allSelected = true;
        this.isProductSelected = true;
        for (let i = 0; i < this.dataMapProduct.length; i += 1) {
          if (this.dataMapProduct[i].registrationId === option.registrationId) {
            this.dataMapProduct[i].selected = !this.dataMapProduct[i].selected;
            break;
          }
        }
        for (let i = 0; i < this.dataMapProduct.length; i += 1) {
          if (
            this.dataMapProduct[i].productName !== 'All'
            && !this.dataMapProduct[i].selected
          ) {
            allSelected = false;
            break;
          }
        }
        if (option.productName === 'All') {
          for (let i = 0; i < this.dataMapProduct.length; i += 1) {
            this.dataMapProduct[i].selected = this.dataMapProduct[0].selected;
          }
        } else this.dataMapProduct[0].selected = allSelected;
        this.checkProduct();
      }
    },
    reRenderChart(chartType) {
      this.country = '';
      let selectedProductCount = 0;
      if (chartType === 'stack') {
        this.$refs.drpDown.search = '';
        if (!this.dataProduct[0].selected) {
          this.dataProduct.forEach((product, j) => {
            if (j === 0) {
              this.productList[j].selected = false;
              return;
            }
            if (product.selected === true) selectedProductCount += 1;
            for (let i = 0; i < this.productList.length; i += 1) {
              if (
                this.productList[i].productName
                === product.productName
              ) {
                this.productList[i].selected = product.selected;
              }
            }
          });
        }

        this.registrationIdList = [];
        this.productDropDownLabel = '';
        this.productList.forEach((product, i) => {
          if (this.dataProduct[0].selected === true) {
            this.productDropDownLabel = 'All';
            this.productList[i].selected = true;
            this.registrationIdList.push(product.registrationId);
          } else if (product.productName !== 'All' && product.selected) {
            this.registrationIdList.push(product.registrationId);
          }
        });
        if (this.productDropDownLabel !== 'All') this.productDropDownLabel = `${selectedProductCount} selected`;
        this.filterCountryChartData('stack');
      } else if (chartType === 'map') {
        this.isCountrySelected = false;
        this.isCheckedCounter = 0;
        // this.$refs.drpDown.search = '';
        this.mapProductDropDownLabel = '';
        if (!this.dataMapProduct[0].selected) {
          this.dataMapProduct.forEach((product, j) => {
            if (j === 0) {
              this.mapProductList[j].selected = false;
              return;
            }
            if (product.selected === true) selectedProductCount += 1;
            for (let i = 0; i < this.mapProductList.length; i += 1) {
              if (
                this.mapProductList[i].productName
                === product.productName
              ) {
                this.mapProductList[i].selected = product.selected;
              }
            }
          });
        }
        this.mapRegistrationIdList = [];
        this.mapProductList.forEach((product, i) => {
          if (this.dataMapProduct[0].selected === true) {
            this.mapProductDropDownLabel = 'All';
            this.mapProductList[i].selected = true;
            this.mapRegistrationIdList.push(product.registrationId);
          } else if (product.productName !== 'All' && product.selected) {
            this.mapRegistrationIdList.push(product.registrationId);
          }
        });
        if (this.mapProductDropDownLabel !== 'All') this.mapProductDropDownLabel = `${selectedProductCount} selected`;
        this.filterCountryChartData('map');
        this.disabledClrBtn = false;
      }
    },

    closeModal(e) {
      if (this.editFlag) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      this.activeId = '';
      return true;
    },
    hidePopup(value) {
      this.editFlag = value;
    },
    activatePopover() {
      this.openPopover = false;
      this.clickPopover = true;
    },
    deactivatePopover() {
      if (window.scrollY && this.clickPopover) {
        this.openPopover = true;
      }
    },
    hidePopover() {
      this.clickPopover = false;
    },
    checkProduct() {
      this.isCheckedCounter += 1;
    },
    onBlurDropdown() {
      if (this.isCheckedCounter > 0) {
        this.reRenderChart('map');
      }
    },
  },
  async created() {
    this.getDashboardSummary();
    this.getChartsDataOverView();
    await this.validateFeatures();
    window.addEventListener('scroll', this.deactivatePopover);
    this.notificationTabName = 'registration-tracker';
    this.defaultStartAndEndDates();
    EventBus.$on('updateLanguage', (language, oldLanguage) => {
      if (language !== oldLanguage) {
        this.$router.go();
      }
    });
  },
  beforeDestroy() {
    $('.tracker-map-tooltip').remove();
    // window.removeEventListener('resize', this.drawWorldMap);
    window.removeEventListener('scroll', this.deactivatePopover);
  },
  mounted() {
    this.loadVerticalStackedBarChart();
    d3.select('body')
      .append('div')
      .attr('class', 'tracker-map-tooltip')
      .style('display', 'none');
    $('.tracker-map-tooltip').on('click', '.small', (event) => {
      this.viewRegistration(event.target.getAttribute('slot'), null, null);
    });
    // window.addEventListener('resize', this.drawWorldMap);
    $('#registrationDetail').on('hide.bs.modal', this.closeModal);
    EventBus.$on('newNotificationsCount', async (newNotificationsCount) => {
      this.notificationsStarMarkCount = newNotificationsCount;
      await this.getAllActiveServicesCounts();
      EventBus.$emit('loadActiveNotificationTab');
    });
    EventBus.$on('updateRegWatch', async () => {
      await this.getAllActiveServicesCounts();
    });
  },
};
</script>

<style scoped>
.welcome-header-wrapper {
  display: flex;
  align-items: center;
}
.contact-us-button-wrapper {
  display: flex;
  justify-content: flex-end;
}
.contact_us_button, .contact_us_button:hover
{
	padding: 6px 16px 6px 16px;
	background-color: #FFFFFF;
	cursor: pointer;
	min-width: 143px;
  height: 44px;
	border: 1px solid #000001;
	color: #000000;
	font-size: 18px;
  font-weight: 600;
  line-height: 25px;
	border-radius: 3px;
	box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
	display: flex;
	align-items: center;
	justify-content: center;
}
.pl-15 {
  padding-left:15px;
}
.ml-15{
  margin-left: 15px;
}
.flex-center {
  display:flex ;
  align-items: center;
  padding-left: 73px !important;
  padding-right: 0px;
}
.r-3{
  right: 3px;
}
.mt-30 {
  margin-top: 30px;
}
.pl-16 {
  padding-left: 16px;
}
.pl-13 {
  padding-left: 13px;
}
.cards {
  display: flex;
  justify-content: space-between;
  max-width: 1305px;
}

.widget1 {
  padding: 17px 0px 8px 24px;
  min-height: 414px;

  /* border-radius: 10px; */
  background: #ffffff;
  margin-right: 24px;
  /* margin-left: 10px; */
  margin-left: 8px;
  margin-top: -6px;
  border: 1px solid #B3B3B3;

}

.widget2 {
  padding: 18px 8px 8px 21px;
  min-height: 414px;

  /* border-radius: 10px; */
  background: #ffffff;
  margin-right: 24px;
  margin-top: -6px;
  border: 1px solid #B3B3B3;
}

.widget3 {
  padding: 17px 8px 8px 24px;
  min-height: 414px;

  /* border-radius: 10px; */
  background: #ffffff;
  margin-right: 24px;
  margin-top: -6px;
  border: 1px solid #B3B3B3;
}

.notification-line {
  border-top: 0.5px solid #C4C4C4;
  margin-right: 15px;
  /* padding-top: 8px; */
}

.marketplace_line {
  border-top: 0.5px solid #C4C4C4;
  margin-left: 13px;
  margin-right: 15px;
}
.market_news_main {
  /* margin-top: 33px; */
  margin: 24px 9px 0px 8px;
  background: #fff;
  border: 1px solid #B3B3B3;
  height: 337px;
  padding: 17px 8px 8px 15px;
  position: relative;
  max-width: 1274px;
}
.notification-main {
    margin: 23px 9px 0px 8px;
    min-height: 359px;
    background: #fff;
    border: 1px solid #B3B3B3;
    position:relative;
    max-width: 1274px;
  }

.notifications_header {
  /* padding-left: 11px; */
  font-size: 24px;
  color: #3E3E3E;
  font-weight: 300;
  line-height: 33px;
  padding-bottom: 8px;
}

.marketplace_header {
  padding-left: 15px;
  font-size: 24px;
  color: #000000;
  font-weight: 300;
  line-height: 33px;
  margin: 0px;
}

.welcome-banner {
  margin: 0px;
  padding: 10px 12px 87px 23px;
  background: url(/static/images/logos/TopBanner.jpg) no-repeat;
  background-size: cover;
  color: #ffffff;
}

.welcome-header {
  font-weight: 300;
  font-size: 42px;
  line-height: 57px;
  margin: 10px 0 0 -12px;
  color: #FFFFFF;
}

.welcome-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #FFFFFF;
  margin: 8px 0 0 -12px;
  padding-bottom: 16px;
}
.market_news  {
  margin-bottom:-15px;
  margin-left: 11px;
}

.mt--45 {
  margin-top: -45px;
}

.p-r-10 {
  padding-right: 10px;
}

.va-middle {
  vertical-align: middle;
}

.ht-15 {
  height: 15px;
}
.ptb-10{
  padding-top: 11px;
  padding-bottom:3px

}

.islands-div {
  color: #606266;
  font-size: 12px;
  padding: 20px 10px 10px 0px;
}

.p-15 {
  padding: 15px;
}

.lt-20 {
  left: 20px;
}

.lt-30 {
  left: 30px;
}

.mt-5 {
  margin-top: 5px;
}
.ask_question_text {
  padding-left:18px;
}
.contact_us_text {
  padding-left: 17px;
}
.virtual_tour_text {
  padding-left: 14px;
}
.pl-28 {
  padding-left: 28px;
}

.pl-8 {
  padding-left: 8px
}

.pr-25 {
  padding-right: 24px
}
.headline_buttons {
  font-size: 18px;
  color: #01518a;
  float: right;
  cursor: pointer;
  font-weight: 700;
  line-height: 25px;
  /* padding-right: 10px; */
}

@media only screen and (min-width: 768px) {
  .lt-100 {
    left: 100px;
  }

  .mt-20 {
    margin-top: 20px;
  }

  .mapIcon {
    left: 0px;
    margin-top: 5px;
  }
}

@media only screen and (max-width: 600px) {
  .rt-30 {
    right: 0 !important;
  }

  .rt-50 {
    right: 0 !important;
  }

  .mt-5-xs {
    margin-top: 5px;
  }

  .mt-10-xs {
    margin-top: 10px;
  }

  .rt-10-xs {
    right: 10px !important;
  }
}

@media only screen and (min-width: 992px) {
  .lt-100 {
    left: unset;
  }

  .mt-20 {
    margin-top: 0px;
  }

  .mapIcon {
    margin-top: 5px;
  }

  .toggle_map {
    left: 0px;
  }
}

@media (min-width: 1025px) and (max-width: 1300px) {
  .exportUL {
    float: right;
  }

  .expiring-soon-border {
    display: table;
  }
}

@media only screen and (min-width: 1300px) {
  .country-dropdown {
    padding-left: 30px !important;
  }
}
@media (min-width: 1301px) and (max-width: 1399px){
  .flex-center {
  padding-left: 11px !important;
}
  .welcome-banner {
    background-repeat: round;
}
}

@media only screen and (max-width: 1024px) {
  .content-wrappper .widget {
    margin-bottom: 20px !important;
  }
}

@media only screen and (max-width: 767px) {
  .mt-xs-10 {
    margin-top: 10px;
  }

  .country-dropdown {
    padding-left: 6px !important;
  }

  .list-title {
    font-size: 22px !important;
  }

  .p-xs {
    padding: 0px !important;
    font-size: 14px !important;
  }

  .table>thead>tr>th {
    padding: 0px !important;
  }

  .table>tbody>tr>td {
    font-size: 12px !important;
    padding-left: 0px !important;
    text-align: center;
  }
}

.dashboard-container {
  padding: 0 15px;
  font-family: 'Open Sans';
  font-style: normal;
  background: #ebebeb;
  padding-bottom: 20px;
}

/* .widget {
  min-height: 280px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.27);
  border-radius: 10px;
  padding: 24px;
  background: #ffffff;
} */
.list-view-widget {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  background: #ffffff;
}

.MT-25 {
  margin-top: 25px;
}

.border_line .border_cls {
  border: 0.5px solid #0b3c61;
  margin-top: 25px;
}

.border_line {
  padding-right: 0px;
}

.export-menu {
  left: -39% !important;
}

.border_dot {
  padding-left: 0px;
}

.border_dot .border_cls {
  border-radius: 50%;
  width: 5px;
  height: 5px;
  background: #174c76;
  margin-top: 23px;
}

/* .dashboard-container {
  background: #f2f2f2;
} */
.rt-0 {
  right: 0;
}

.rt-10 {
  right: 10px;
}

.rt-30 {
  right: 30px;
}

.rt-50 {
  right: 50px;
}

.list-title {
  font-weight: 500;
  font-size: 19px;
  line-height: 36px;
  /* Emergo Dark Blue */
  color: #0b3c61;
}

.table-title {
  font-weight: 300;
  font-size: 24px;
  line-height: 28px;
  color: #000000;
}

.pl-0 {
  padding-left: 0px;
}

.pl-5 {
  padding-left: 5px;
  cursor: pointer;
}

.pb-25 {
  padding-bottom: 25px;
}

.pl-60 {
  padding-left: 60px !important;
}

.pl-80 {
  padding-left: 80px !important;
}

.country-dropdown {
  padding-left: 60px;
}

.pl-8 {
  padding-left: 8px !important;
}

.background_fff {
  background: #ffffff;
}

.country-border {
  border-bottom: 2px solid #828282;
}

.expired-border {
  border-bottom: 2px solid #eb5757;
}

.expiring-soon-border {
  border-bottom: 2px solid #f2994a;
}

.pending-border {
  border-bottom: 2px solid #9b51e0;
}

.active-border {
  border-bottom: 2px solid #f2c94c;
}

table,
td {
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
}

table,
.showMap {
  height: 470px;
}

table>tbody>tr {
  border-bottom: 0.5px solid #bdbdbd;
  border-collapse: collapse;
}

.table>thead>tr>th {
  border-bottom: none;
  cursor: default;
}

tbody {
  max-height: 470px;
  display: block;
  overflow-y: auto;
}

thead,
tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.notifications_new_project {
  font-weight: 300;
  font-size: 18px;
  line-height: 25px;
  color: #0b3c61;
  padding-left: 40px;
}

.notifications {
  display: flex;
  align-items: center;
  /* margin-top:17px */
  padding: 17px 0px 22px 25px
}

h1 {
  font-size: 1.5em;
  /* text-align: center */
  color: #4f90c3;
  font-weight: lighter;
}

.dashboard_row {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-left: 10%;
  margin-right: 10%;
  margin-bottom: 20px;
}

.dashboard_cell {
  flex: 1 0 auto;
  border-radius: 5px;
  margin-left: 5px;
  margin-right: 5px;
  min-height: 190px;
  max-height: 190px;
  overflow: hidden;
  height: 190px;
  transition: all 200ms ease-in-out;
  width: 30%;
}

.red {
  background-color: #CF5F28;
}

.orange {
  background-color: #F2994A;
}

.dark_blue {
  background-color: #00a5f5;
}

.light_blue {
  background-color: #41a1cf;
}

.dashboard_cell:hover>.dashboard_cell_summary {
  margin-top: -190px;
}

.dashboard_cell:hover {
  -webkit-box-shadow: 0px 9px 44px -12px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 44px -12px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 44px -12px rgba(0, 0, 0, 0.75);
}

.dashboard_cell_details {
  height: 100%;
}

.dashboard_cell_summary {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  transition: all 200ms ease-in-out;
}

.big_number {
  font-size: 5em;
  font-weight: bold;
  color: white;
  margin-bottom: 20px;
  margin-top: 10px;
}

.summary_subtitle {
  color: white;
  font-weight: bold;
  margin-top: 9px;
}

.details_header {
  width: 100%;
  padding: 10px;
  font-weight: bold;
  color: white;
}

.details_contents {
  padding: 10px;
  width: 100%;
  height: 78%;
  overflow-y: scroll;
}

.details_contents a:hover {
  cursor: pointer;
}

.dashboard_cell_country {
  flex: 1 0 auto;
  border: 1px solid #cccccc;
  border-radius: 5px;
  margin-left: 5px;
  margin-right: 5px;
  min-height: 190px;
  max-height: 190px;

  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 30%;
}

.cell_country_header {
  width: 100%;
  padding: 10px;
  font-weight: bold;
  border-bottom: 1px solid #cccccc;
  flex: 0 0 auto;
  text-align: center;
  display: flex;
}

.cell_country_summary {
  padding: 10px;
  height: 78%;
  transition: all 200ms ease-in-out;
}

.country_summary_list {
  flex: 1 0 auto;
  padding: 10px;
  overflow-y: scroll;
  display: inline-block;
}

.big_flag {
  font-size: 65px;
  top: 5px;
}

.country_summary_list::-webkit-scrollbar {
  width: 12px;
}

.country_summary_list::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #ffffff;
  border-radius: 10px;
}

.country_summary_list::-webkit-scrollbar-thumb {
  background: #d4d4d4;
  border-radius: 10px;
  border: 2px solid white;
}

.country_summary_list>.status_header {
  font-weight: bold;
}

.expiring_soon {
  color: #ffaa49;
}

.expired {
  color: #ff0606;
}

.pending {
  color: #4f90c3;
}

.active {
  color: #013a68;
}

.details_contents::-webkit-scrollbar {
  width: 12px;
}

.details_contents::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #ffffff;
  border-radius: 10px;
}

.details_contents::-webkit-scrollbar-thumb {
  background: #d4d4d4;
  border-radius: 10px;
  border: 2px solid white;
}

.country_list {
  padding: 10px;
  overflow-y: scroll;
}

.btnExportClass {
  border: 1px solid #0b3c61;
  border-radius: 16px;
  font-family: 'Open Sans' !important;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #0b3c61 !important;
  width: 120px;
  padding-left: 0px;
  line-height: 17px;
}

.exportUL {
  text-align: right;
}

.dropdown-export {
  display: block !important;
}

.country_list::-webkit-scrollbar {
  width: 12px;
}

.country_list::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #ffffff;
  border-radius: 10px;
}

.country_list::-webkit-scrollbar-thumb {
  background: #d4d4d4;
  border-radius: 10px;
  border: 2px solid white;
}

.col_country {
  flex: 2 0 105px;
  text-align: left;
  flex-wrap: wrap;
}

.col_exp_soon {
  flex: 1 0 auto;
}

.col_active {
  flex: 0 0 auto;
}

.country_row {
  display: flex;
}

.fa-globe {
  padding-right: 10px !important;
}

.detailcontent_wrapper {
  position: relative;
}

.cursor_pointer {
  cursor: pointer !important;
  word-break: break-all;
  white-space: normal;
}

.country-dropdown>>>.v-select .open-indicator {
  left: 90%;
}

.country-dropdown>>>.v-select .dropdown-toggle {
  width: 100%;
}
.ask_question_image {
  width:18px;
  height:18px;
}
.virtual_tour_image {
  width: 26px;
  height: 26px;
}
.contact_us_image {
  width: 20px;
  height: 20px;
}

@media only screen and (min-width: 1200px) {
  .ml-10 {
    margin-left: 10px;
  }

  .wd-80 {
    width: 120px;
  }
}

@media (min-width: 992px) and (max-width: 1200px) {
  .country-dropdown {
    padding-left: 0px;
  }

  .p-m-0 {
    padding: 0px !important;
  }
}

.txt-alg-rt {
  text-align: right;
}

@media (min-width: 1025px) and (max-width: 1150px) {
  .country-dropdown {
    padding-right: 0px;
  }

  .list-title {
    padding-left: 0px;
  }
}

@media (min-width: 768px) and (max-width: 992px) {
  .country-dropdown {
    padding-left: 15px;
    padding-right: 0px;
  }

  .p-m-0 {
    padding: 0px !important;
  }

  .wd-80 {
    width: 80px;
  }

  .wd-110 {
    width: 105px;
  }

  .sm-pl-0 {
    padding-left: 0;
  }
}

.txt-alg-rt {
  text-align: right;
}

@media screen and (max-width: 767px) {
  .country-dropdown {
    padding-left: 0px;
  }

  .p-m-0 {
    padding: 0px !important;
  }

  .btnExportClass {
    width: 80px;
  }
}

.txt-alg-rt {
  text-align: right;
}

.notification_image {
  width: 24px;
  height: 24px;
  margin-left: 7px;
  margin-bottom: 7px;
}

.marketplace_image {
  width: 22px;
  /* margin-left: 15px; */

}

.header_text {
  font-weight: 700;
  font-size: 18px;
  line-height: 25px;
  color: #FFFFFF;
  cursor: pointer;
}

@media (min-width: 1578px) {
  .cards, .market_news_main, .notification-main {
    margin-left: auto;
    margin-right: auto;
  }
}

</style>
